<template>
  <div class="out">
    <div class="page-title">
      <div class="container">
        <b-jumbotron
          :header="header"
          :lead="leader"
          header-tag="h1"
          style="background-color: rgba(0, 0, 0, 0);width:780px"
        />
      </div>
    </div>
    <div class="stickybar">
      <a :style="partI===true ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(1)">业务挑战</a>
      <a :style="partII===true ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(2)">解决方案</a>
      <a :style="partIII===true ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(3)">解决方案优势</a>
      <a :style="partIV===true ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(4)">成功故事</a>
      <!-- <a :style="partV===true ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(5)">相关产品</a> -->
    </div>
    <div
      ref="parti"
      class="review"
      style="background-color: rgba(255, 255, 255); margin-left: 0; margin-right: 0"
    >
      <div class="title">
        <div id="partone" class="top-text contenttext">
          <h3>业务挑战</h3>
        </div>
        <introduceCard :arr="cardarr" style="padding-bottom:90px" />
      </div>
    </div>
    <div
      id="parttwo"
      ref="partii"
      class="review"
      style="background-color: rgba(255, 255, 255); margin-left: 0; margin-right: 0;background:url('https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202009/241617597vx6.png') no-repeat"
    >
      <div class="title">
        <p class="contenttext" style="color:white;text-align:center">
          <br >建筑行业数字化转型解决方案
        </p>
        <div class="introducecard-frame">
          <div v-for="(item,index) in arr2" :key="index" :class="{hoverChange:nowindex2 === index}" class="introducecard2" @mouseenter="mouseOver2(index)" @mouseleave="mouseLeave2(index)">
            <div :style="nowindex2===index ? 'overflow:visible;color:white':'overflow:hidden;color:white'" class="introduceText animation">
              <div class="card-title2"><h4>{{ item.title }}</h4></div>
              <div class="card-text2">{{ item.content }}</div>
              <div v-if="nowindex2===index" class="introduceButton2">
                <router-link class="experience-link" to="/aboutUs">详情咨询</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      id="partthree"
      ref="partiii"
      class="review"
      style="background-color: rgba(128, 126, 126, 0.074); margin-left: 0; margin-right: 0"
    >
      <div class="title">
        <p class="contenttext">
          <br >解决方案优势
        </p>
        <introduceCard3 :arr="cardarr2" style="padding-bottom:90px" />
        <!-- <div class="introducecard-frame">
          <div v-for="(item,index) in arr3" :key="index" class="introducecard2" style="height:364px">
            <div class="image3">
              <img src="https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/1118203743vj.png" alt="">
            </div>
            <div :class="{hoverChange2:nowindex3 === index}" class="introduceText3" @mouseenter="mouseOver3(index)" @mouseleave="mouseLeave3(index)">
              <div class="card-title3"><h4>{{ item.title }}</h4></div>
              <div class="card-text3">{{ item.content }}</div>
              <a v-if= "nowindex3 === index">
                <div class="mybtn" >案例详情</div>
              </a>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <div
      id="partfour"
      ref="partiv"
      class="review"
      style="background: rgba(234,239,243,1); margin-left: 0; margin-right: 0;padding-bottom: 60px;"
    >
      <div class="title">
        <card :arr3="arr3" />
      </div>
    </div>
    <!-- <div
      id="partfive"
      ref="partv"
      class="review"
      style="background-color: rgba(128, 126, 126, 0.074); margin-left: 0; margin-right: 0"
    >
      <div class="title">
        <p class="contenttext">
          <br >相关产品
        </p>
        <div class="introducecard-frame">
          <div v-for="(item,index) in arr" :key="index" :class="{hoverChange:nowindex === index}" class="introducecard" @mouseenter="mouseOver(index)" @mouseleave="mouseLeave(index)">
            <div v-if="nowindex !== index" class="introduceImage">
              <img :src="item.link" alt="">
            </div>
            <div class="introduceText">
              <div class="card-title"><h4>{{ item.title }}</h4></div>
              <div class="card-text">{{ item.content }}</div>
              <div :style="nowindex===index ? {'opacity':1,'marginTop':'40%'} :'opacity:0'" class="introduceButton">
                <a class="experience-link" href="/access">免费体验</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
import introduceCard3 from '@/components/introducecard3'
import introduceCard from '@/components/introducecard2'
import Card from '@/components/introducecard'
export default {
  name: 'Build',
  components: { introduceCard, Card, introduceCard3 },
  data() {
    return {
      header: '房地产行业解决方案',
      leader: '深耕行业20载，与中国企业共同成长，产品持续创新，引领房地产企业数字化转型',
      cardarr: [
        { title: '挑战：数字化经济时代竞争力要素发生变化', content: '企业面临的最大挑战是如何规划和实施数字化商业模式转型，企业对数字化转型的价值洞察、转型目标与顶层设计、数字化技术与业务的整合，实施规划与过程保障都将直接影响房地产数字化转型的成败', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/14214546mgyk.png' },
        { title: '机遇：数字化改变客户体验、管理运营、商业模式', content: '数字化技术与管理的融合促进房企实现商业模式创新。房地产企业精准推进数字化转型可以从数字化营销、数字化运营、数字化产品、数字化服务、数字化人才等领域获得突破', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/14215129qykn.png' }
      ],
      cardarr2: [
        { title: '平台致胜 助力创新', content: '以内容定义平台，把平台做成生态，以生态服务内容。数字化技术平台对企业平台战略起着重要作用，连接生态，业务调整、管理创新都依赖数字化技术平台稳定性、灵活性、扩展性和自主可控', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/14215239jhgb.png' },
        { title: '经营视角 全局管控', content: '企业的一切业务与管理活动都是围绕经营目标实现而开展，经营预算、项目管理、采购管理、营销服务、人才战略等都是实现经营目标中的一环。各领域管理活动都需要以经营为导向，实现全局经营统筹', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/14215317m2jy.png' }
      ],
      arr2: [
        { title: '数字化营销', content: '从客户视角，通过互联网技术，建立与客户的连接，为客户提供精准服务，将客户作为核心资产持续经营。从产品（房源或资产）视角，通过货值规划、营销计划、租售过程的产品价值实现，达成项目经营目标' },
        { title: '产业互联采购管理', content: '连接供应商，打通企业与供应商、物流商间信息流、资金流与物流协同，实现企业与供应商端到端业务连接，通过采购业务链协作，不断沉淀企业优质合作伙伴体系。通过建立统一业务处理、数据共享平台，实现采购线上、线下业务融合，提升采购效益' },
        { title: '经营视角下的成本管理', content: '从经营视角出发，以项目利润合理、现金流健康为决策依据的管理理念贯穿目标成本合约管理动态成本全过程，实现成本、财务、税务管理一体化' },
        { title: '项目统筹运营', content: '以项目经营目标为导向，建立标准的项目主数据，统一项目经营管理口径，以项目计划连接和驱动各业务，实现项目全过程中业务、财务、税务的动态管理闭环' }
      ],
      arr3: [
        { title: '荣安地产：业财税一体化驱动转型升级', content: '', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/12112141mf3z.png' },
        { title: '金地集团：千亿级地产企业数字化创新标杆', content: '', link: 'https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/121120192y7g.png' }
      ],
      nowindex: '',
      nowindex2: '',
      nowindex3: '',
      nowindex4: 0,
      nowIndex: [0],
      partI: false,
      partII: false,
      partIII: false,
      partIV: false
      // partV: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.scrollLisenter)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollLisenter)
  },
  methods: {
    jump: function(x) {
      if (x === 1) {
        x = '#partone'
      }
      if (x === 2) {
        x = '#parttwo'
      }
      if (x === 3) {
        x = '#partthree'
      }
      if (x === 4) {
        x = '#partfour'
      }
      if (x === 5) {
        x = '#partfive'
      }
      document.querySelector(x).scrollIntoView(true)
    },
    scrollLisenter: function() {
      var length = document.documentElement.scrollTop + 37
      if (length >= 0 && length < this.$refs.partii.offsetTop) {
        this.partI = true
      } else this.partI = false
      if (length > this.$refs.partii.offsetTop && length < this.$refs.partiii.offsetTop) {
        this.partII = true
      } else this.partII = false
      if (length > this.$refs.partiii.offsetTop && length < this.$refs.partiv.offsetTop) {
        this.partIII = true
      } else this.partIII = false
      // if (length > this.$refs.partiv.offsetTop && length < this.$refs.partv.offsetTop) {
      //   this.partIV = true
      // } else this.partIV = false
      if (length > this.$refs.partiv.offsetTop) {
        this.partIV = true
      } else this.partIV = false
    },
    mouseOver: function(x) {
      this.nowindex = x
    },
    mouseLeave: function(x) {
      this.nowindex = -1
    },
    mouseOver2: function(x) {
      this.nowindex2 = x
    },
    mouseLeave2: function(x) {
      this.nowindex2 = -1
    },
    mouseOver3: function(x) {
      this.nowindex3 = x
    },
    mouseLeave3: function(x) {
      this.nowindex3 = -1
    },
    mouseOver4: function(x) {
      this.nowindex4 = x
    },
    mouseLeave4: function(x) {
      this.nowindex4 = x
    },

    mouseOvers: function(type, index) {
      this.nowIndex[type] = index
    },
    mouseLeaves: function(type, index) {
      this.nowIndex[type] = 0
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}

.out{
  display: inline-block;
  vertical-align:top;
  width:100%;
}

.page-title {
  background: url('https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202010/20171653rwc4.png') no-repeat;
  background-size: 100% 100%;
  height: 100%;
  text-align: left;
  padding-top: 60px;
  padding-bottom: 2px;
  /* max-width: 1200px; */
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.title {
  width: 1200px;
  text-align: center;
  margin: 0 auto;
}

.titletext {
  font-size: 50px;
  font-family: "Permanent Marker", cursive;
  color: rgb(22, 21, 21);
}

.contenttext {
  color: rgb(0, 0, 0);
  font-size: 32px;
  /* font-family: Georgia, "Times New Roman", Times, serif; */
  text-align: center;
  padding: 6%;
  padding-top: 4%;
  margin:0;
}

.top-text {
  padding: 50px 0 50px 0;
}

.card {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.introducecard-frame{
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 50px;
}

.introducecard {
  background-color: rgba(236, 234, 227, 0.39);
  width:293px;
  height:315px;
  display: flex;
  flex-direction: column;
  text-align: center;
  margin: 3px;
  position: relative;
}

.introducecard2 {
  /* background-color: rgba(243, 241, 235, 0.473); */
  /* background-color:rgba(247,247,247,1); */
  background: rgba(35,133,237,0.2);
  height:264px;
  width:584px;
  display: flex;
  flex-direction: column;
  text-align: center;
  position: relative;
  margin:0px 8px 20px 8px;
}

.introduceImage {
  padding-top: 50px;
}

.introduceText {
  padding: 20px 30px 30px 30px;
}

.introduceButton {
  border:1px solid rgba(255,255,255,1);
  background-color: rgba(59, 124, 209, 0.39);
  opacity: 0;
  width:100px;
  margin: auto;
  ;
}

.introduceButton2 {
  border:1px solid rgba(255,255,255,1);
  bottom: 75px;
  background-color: rgba(0, 203, 253, 1);
  width:100px;
  margin: auto;
}

.introduceButton a {
    color:rgba(251,252,253,1);
    font-size:14px;
    text-align: center;
    line-height: 40px;
    text-decoration: none;
}

.introduceButton2 a {
    color:rgba(251,252,253,1);
    font-size:14px;
    text-align: center;
    line-height: 40px;
    text-decoration: none;
}

.hoverChange {
  background-color: rgba(20, 130, 238, 1);
  transition: 0.4s;
  color:white;
  box-shadow: 0px 0px 5px #000;
}

.animation {
  position: relative;
  transition: all 0.4s;
}

.animation:hover {
  transition: transform 0.4s;
  transform: translateY(-40px);
}

.card-title2 {
  margin-top: 10%;
  text-align: left;
}

.card-title3 {
  margin-top: 1%;
  text-align: left;
}

.card-text2 {
  word-break:hyphenate;
  font-size: 14px;
  padding-top: 2%;
  padding-bottom: 2%;
  text-align: left;
  height:120px;
}

.card-text3 {
  font-size: 14px;
  text-align: left;
}

.introduceText3 {
  background-color: rgb(255, 255, 255);
  position: absolute;
  bottom:0;
  transition: all 0.4s;
  height: 140px;
  padding:4%;
}

.introduceText3:hover {
  height: 200px;
  transition:0.4s;
}

.introducecard2 img {
  width:100%;
}

.mybtn {
  width:25%;
  background-color: rgb(62, 88, 112);
  margin: 30px auto;
  padding: 1%;
  color: white;
}

.leftMenu {
  display: flex;
  flex-direction: column;
  width: 150px;
  text-align: left;
  padding: 10% 0%;
  box-shadow: -20px 0px 20px -10px rgb(0 0 0 / 4%) inset;
}

.leftMenu-item {
  padding:18% 10% 18% 10%;
  position: relative;
}

.rightContent {
  width: 100%;
  background-color: rgba(128, 126, 126, 0.075);
  padding:10%;
}

.hoverItem {
  background-color: rgba(45,139,238,1);
  color: ivory;
  width:140%;
  font-size: 20px;
}

.big-title {
  margin: auto;
  padding:5%;
}

.stickybar {
  position: sticky;
  top: 0;
  display: flex;
  background-color: white;
  z-index: 99;
  padding: 0% 7% 0% 13%;
}

.stickybar a{
  padding: 2% 4%;
  cursor: pointer;
  text-decoration: none;
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/views/solutions/components/estate.vue